import React from 'react'
import { Row, Col, Form, Checkbox } from 'antd'
import difference from 'lodash/difference'
import './index.less'

const FormItem = Form.Item

export default class SellersAction extends React.Component {
  constructor(props) {
    super(props)

    // console.log('dadad',this.props)
    this.handleChangeValues(props.value.split(','))
    this.state = {
      values: props.value.split(','),
      indeterminate: true,
      checkAll: false,
    }
  }

  handleChangeValues = (values) => {
    const { sellers } = this.props
    this.setState({
      values,
      indeterminate: values.length !== sellers.length,
    })
    this.props.onChange(values.join(','))
  }

  onCheckAllChange = (e) => {
    const { sellers } = this.props
    const allSellers = []
    sellers.map((item, key) => allSellers[key] = item.key)

    console.log(e.target.checked, allSellers)
    this.setState({
      values: e.target.checked ? allSellers : [],
      indeterminate: false,
      checkAll: e.target.checked,
    })
  };

  render() {
    const { sellers } = this.props
    const { values } = this.state

    return (
      <div>
        <div style={{ borderBottom: '1px solid #E9E9E9' }}>
          <Checkbox
            indeterminate={this.state.indeterminate}
            onChange={this.onCheckAllChange}
            checked={this.state.checkAll}
          >
            Все торговые сети
          </Checkbox>
        </div>
        <br />
        <Checkbox.Group onChange={this.handleChangeValues} value={values}>
          <Row type='flex' justify='start' gutter={32}>
            {sellers.map((item, key) =>
              (<Col key={item.key} xs={24} sm={24} md={12} lg={12} xl={8} xxl={6}>
                <Checkbox value={item.key}>{item.title}</Checkbox>
               </Col>))}
          </Row>
        </Checkbox.Group>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/containers/ActionForm/Sellers.jsx